<div class="ap-grid-form" [@transalteEditForm]="formState$ | async"
     (@transalteEditForm.done)="destroyComponent()">
    <ng-template adHost></ng-template>
</div>
